<div>
  <div class="boxTex" *ngIf="notifications.length===0">{{'notifications.noNotifications'|transloco}}</div>
  <span *ngFor="let notification of notifications; last as isLast">
    <app-notification-list-element [notification]="notification"/>
    <hr class="noMargin" *ngIf="!isLast">
  </span>
</div>
